import { Html } from "@custom/schema";
import clsx from "clsx";
import { motion } from "framer-motion";
import React from "react";
import ArrowLink from "../molecules/ArrowLink";
import PromoBanner from "../molecules/PromoBanner";
import VideoModalButton from "../molecules/VideoModalButton";
export default function HeroSection(props) {
    var _props_arrowCta, _props_arrowCta1;
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative overflow-hidden px-6 md:px-14 lg:mt-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl pt-8 md:pt-[5.5rem] lg:pt-24 pb-10 lg:pb-14 relative"
    }, /*#__PURE__*/ React.createElement(RotatingSvg, null), /*#__PURE__*/ React.createElement("img", {
        src: "/images/hero-angle-mob.svg",
        width: "380",
        alt: "Angle pattern header background",
        className: "md:hidden absolute bottom-5 -right-[230px] sm:-right-60 max-w-[unset]"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center sm:text-left"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-[2rem] leading-tight md:text-5xl lg:text-6xl xl:text-7xl font-heading font-semibold"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "inline-block lg:pt-4 pb-4 md:pb-3 lg:pr-[27px]"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: props.heading,
        classNames: {
            em: "text-orange-500 not-italic"
        }
    }))), /*#__PURE__*/ React.createElement("p", {
        className: "text-gray-100 lg:text-xl pb-9 lg:pb-[2.75rem] inline-block lg:min-w-[640px] xl:min-w-[auto]"
    }, props.subheading)), /*#__PURE__*/ React.createElement("div", {
        className: "block"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("sm:flex md:inline-flex lg:flex xl:inline-flex sm:gap-x-4 lg:max-w-xl xl:max-w-full", {
            "lg:pb-[4.4rem] xl:pb-16": !props.arrowCta || ((_props_arrowCta = props.arrowCta) === null || _props_arrowCta === void 0 ? void 0 : _props_arrowCta.label) === "",
            "lg:pb-3": props.arrowCta
        })
    }, props.callToActions && props.callToActions.map(function(cta, key) {
        /*#__PURE__*/ return React.createElement(React.Fragment, null, (cta === null || cta === void 0 ? void 0 : cta.target.includes("wistia")) ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(VideoModalButton, {
            target: cta.target,
            label: cta.label,
            buttonClasses: "w-full md:w-auto mb-4 md:mb-5 lg:mb-0 button-secondary focus bg-white border-gray-600 text-gray-100 hover:bg-gray-600 hover:text-white"
        })) : /*#__PURE__*/ React.createElement("a", {
            key: key,
            href: cta === null || cta === void 0 ? void 0 : cta.target,
            id: cta === null || cta === void 0 ? void 0 : cta.label.replace(/\s+|[^A-Za-z0-9]/g, "").toLowerCase(),
            className: clsx("w-full md:w-auto mb-4 md:mb-5 lg:mb-0", {
                "button-primary focus bg-yellow-500 text-gray-600 border border-yellow-500 hover:border-gray-600 hover:bg-gray-600 hover:text-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "PRIMARY",
                "button-secondary focus bg-white border-gray-600 text-gray-100 hover:bg-gray-600 hover:text-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "SECONDARY"
            })
        }, cta === null || cta === void 0 ? void 0 : cta.label));
    }))), props.arrowCta && ((_props_arrowCta1 = props.arrowCta) === null || _props_arrowCta1 === void 0 ? void 0 : _props_arrowCta1.label) ? /*#__PURE__*/ React.createElement("div", {
        className: "text-center sm:text-left"
    }, /*#__PURE__*/ React.createElement(ArrowLink, {
        target: props.arrowCta.target,
        text: props.arrowCta.label,
        className: "block text-gray-600 pt-2.5 lg:pt-3.5 text-sm pb-3 md:pb-0 lg:pb-9 md:pl-8"
    })) : null, props.promo ? /*#__PURE__*/ React.createElement("div", {
        className: "mt-5 md:mt-9 lg:mt-0 pb-4 max-w-xl"
    }, /*#__PURE__*/ React.createElement(PromoBanner, props.promo)) : null)));
}
function RotatingSvg() {
    var getAnimationConfig = function() {
        if (typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            return undefined;
        }
        return {
            rotate: [
                0,
                55,
                0
            ],
            transition: {
                duration: 18,
                ease: "easeInOut",
                repeat: Infinity,
                repeatType: "mirror"
            }
        };
    };
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1312px",
        height: "1573px",
        viewBox: "0 0 1312 1573",
        version: "1.1",
        className: "knime-hidden md:block absolute bottom-0 -right-[250px] md:-right-[460px] lg:-right-72",
        "data-chromatic": "ignore"
    }, /*#__PURE__*/ React.createElement("title", null, "Hero Angle Pattern@1x"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Homepage:-Updated-Brand",
        transform: "translate(-424.000000, 868.000000)",
        fill: "#FFD900",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Hero",
        transform: "translate(0.000000, 100.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Hero-Angle-Pattern",
        transform: "translate(424.000000, -968.000000)"
    }, /*#__PURE__*/ React.createElement(motion.g, {
        animate: getAnimationConfig()
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0,1361.81977 L266.090716,0 L1312,911.436794 L1296.9061,916.620761 L0,1361.81977 L0,1361.81977 Z M278.055473,34.8748351 L24.2096105,1334.0192 L1275.82832,904.36552 L278.055473,34.8748351 L278.055473,34.8748351 Z",
        id: "Shape",
        transform: "translate(656.000000, 680.909886) scale(-1, 1) translate(-656.000000, -680.909886) "
    })), /*#__PURE__*/ React.createElement(motion.g, {
        animate: getAnimationConfig()
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M184.55431,1415.35588 L284.988629,309.850967 L1191.8221,949.610979 L184.55431,1415.35588 L184.55431,1415.35588 Z M297.491483,336.910718 L201.73043,1390.99147 L1162.14313,946.912651 L297.491483,336.910718 L297.491483,336.910718 Z",
        id: "Shape",
        transform: "translate(688.188205, 862.603421) scale(-1, 1) translate(-688.188205, -862.603421) "
    })), /*#__PURE__*/ React.createElement(motion.g, {
        animate: getAnimationConfig()
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M434.64842,1468.68766 L369.363634,619.935233 L1136.76983,987.747227 L434.64842,1468.68766 L434.64842,1468.68766 Z M382.213474,638.710015 L444.475717,1448.16238 L1114.09239,989.494733 L382.213474,638.710015 L382.213474,638.710015 Z",
        id: "Shape",
        transform: "translate(753.066731, 1044.311445) scale(-1, 1) translate(-753.066731, -1044.311445) "
    })), /*#__PURE__*/ React.createElement(motion.g, {
        animate: getAnimationConfig()
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M785.289127,1521.43604 L554.703889,930.360636 L1181.67828,1026.11976 L785.289127,1521.43604 L785.289127,1521.43604 Z M566.951729,940.168176 L787.657114,1505.92267 L1167.06394,1031.82888 L566.951729,940.168176 L566.951729,940.168176 Z",
        id: "Shape",
        transform: "translate(868.191082, 1225.898337) scale(-1, 1) translate(-868.191082, -1225.898337) "
    })), /*#__PURE__*/ React.createElement(motion.g, {
        animate: getAnimationConfig()
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1133.75594,1573 L740.534165,1240.44192 L744.049417,1239.17893 L1225.00886,1066.03847 L1133.75594,1573 L1133.75594,1573 Z M749.027266,1241.97643 L1130.83403,1564.87275 L1219.43767,1072.63149 L749.027266,1241.97643 L749.027266,1241.97643 L749.027266,1241.97643 Z",
        id: "Shape",
        transform: "translate(982.771513, 1319.519233) scale(-1, 1) translate(-982.771513, -1319.519233) "
    })))))));
}
